import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
export var ExternalLink = forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, weak = _a.weak, children = _a.children, props = __rest(_a, ["className", "weak", "children"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("a", __assign({ target: "_blank" }, props, { ref: ref, className: classNames(classPrefix + "-link-external", (_b = {},
            _b[classPrefix + "-link-external--black"] = weak,
            _b), className) }), children));
});
ExternalLink.displayName = "ExternalLink";
//# sourceMappingURL=ExternalLink.js.map